import "config/LuxonConfig";
import React from "react";
import { BrowserRouter } from "react-router-dom";
import type { IPublicClientApplication } from "@azure/msal-browser";
import { InteractionType } from "@azure/msal-browser";
import { MsalAuthenticationTemplate, MsalProvider } from "@azure/msal-react";
import { loginRequest } from "authConfig";
import { ConfigurationProvider } from "contexts/ConfigurationProvider/ConfigurationProvider";
import { AlertProvider } from "components/AlertProvider/AlertProvider";
import { IdSearchDialog } from "components/IdSearchDialog/IdSearchDialog";
import { ThemeFromLocalStorage } from "components/Theme/ThemeFromLocalStorage";
import { MsalAuthErrorFallback, MsalAuthLoading } from "components/auth/MsalAuthErrorFallback";
import { RbacProvider } from "components/authorization/RbacProvider";

interface AppProps {
  routes: React.ReactElement;
  msalInstance: IPublicClientApplication;
}

export function App({ routes, msalInstance }: AppProps) {
  return (
    <MsalProvider instance={msalInstance}>
      <MsalAuthenticationTemplate
        interactionType={InteractionType.Redirect}
        authenticationRequest={loginRequest}
        errorComponent={MsalAuthErrorFallback}
        loadingComponent={MsalAuthLoading}
      >
        <ThemeFromLocalStorage>
          <ConfigurationProvider>
            <RbacProvider>
              <AlertProvider>
                <BrowserRouter>
                  {routes}
                  <IdSearchDialog />
                </BrowserRouter>
              </AlertProvider>
            </RbacProvider>
          </ConfigurationProvider>
        </ThemeFromLocalStorage>
      </MsalAuthenticationTemplate>
    </MsalProvider>
  );
}
